import React, { useEffect, useState } from 'react';
import styles from './stylesHistoricoLicitaciones.module.css';

const Licitaciones2018 = ({ ciclo, licitaciones }) => {
    const [expandedIds, setExpandedIds] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

const toggleExpansion = (id) => {
    setExpandedIds(prev =>
        prev.includes(id)
        ? prev.filter(i => i !== id)
        : [...prev, id]
    );
};

const normalizarTexto = (texto) => {
    return texto
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/\b(no\.?|nº)\b/g, "")
        .replace(/[^\w\s\/-]/g, "")
        .replace(/\s+/g, " ")
        .trim();
};

const prepararNumeroConvocatoria = (texto) => {
    const limpio = normalizarTexto(texto);
        return limpio
            .replace(/\b0+(\d)/g, '$1')
            .replace(/\//g, ' ')
            .replace(/\s+/g, ' ')
            .trim();
};

const prepararNumeroProcedimiento = (texto) => {
    const limpio = normalizarTexto(texto);
    return limpio
        .replace(/\b0+(\d)/g, '$1')
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, ' ')
        .trim();
};

const esSoloNumero = (texto) => {
    return /^\d+$/.test(texto);
};

const extraerNumeroDesdeFrase = (texto) => {
    const match = texto.match(/\b(?:convocatoria|licitacion)\s+(\d+)\b/);
    return match ? match[1] : null;
};

const filtrarLicitaciones = () => {
    if (!searchTerm.trim()) return licitaciones;

    const term = normalizarTexto(searchTerm);
    const numeroDetectado = extraerNumeroDesdeFrase(term);
    const esNumero = esSoloNumero(term) || !!numeroDetectado;
    const valorBusqueda = numeroDetectado || term;

    return licitaciones
        .map((convocatoria) => {
            const textoConvocatoria = prepararNumeroConvocatoria(convocatoria.numConvocatoria);
            const contieneConvocatoria = textoConvocatoria
                .split(/[\s\-\/]/)
                .some(t => t.includes(valorBusqueda));

            const procedimientosFiltrados = convocatoria.procedimientos.filter((proc) => {
                const textoProcedimiento = prepararNumeroProcedimiento(proc.numProcedimiento);
                const coincideProcedimiento = textoProcedimiento
                    .split(/[\s\-\/]/)
                    .some(t => t.includes(valorBusqueda));

                return (
                    coincideProcedimiento ||
                    normalizarTexto(proc.descripcionProcedimiento).includes(term) ||
                    normalizarTexto(proc.vigencia).includes(term) ||
                    proc.resultados.some(r => normalizarTexto(r.resultado).includes(term))
                );
            });

            if (contieneConvocatoria || procedimientosFiltrados.length > 0) {
                return {
                    ...convocatoria,
                    procedimientos: contieneConvocatoria && procedimientosFiltrados.length === 0
                    ? convocatoria.procedimientos
                    : procedimientosFiltrados
                };
            }

            return null;
        })
        .filter(Boolean);
};

const resultadosFiltrados = filtrarLicitaciones();

const idsExpandirAuto = searchTerm
    ? resultadosFiltrados.map(item => item.idConvocatoria)
    : [];

const estaExpandido = (id) => {
    return searchTerm
    ? idsExpandirAuto.includes(id)
    : expandedIds.includes(id);
};

    return (
        <div className={styles.container}>
            <div className='row'>
                <div className='rubros_titulo'>
                    <h2>Histórico de Procedimientos por Licitación Pública {ciclo}</h2>
                </div>

                {/*<div className={styles.seeker}>*/}
                {/*    <input*/}
                {/*        className={styles['search-input']}*/}
                {/*        type="text"*/}
                {/*        placeholder="Buscar convocatoria, número de procedimiento, descripción de procedimiento, municipio del procedimiento ..."*/}
                {/*        value={searchTerm}*/}
                {/*        onChange={(e) => setSearchTerm(e.target.value)}*/}
                {/*    />*/}
                {/*</div>*/}

                <div className={styles['call-container']}>
                    {searchTerm && licitaciones.length > 0 && resultadosFiltrados.length === 0 ? (
                        <div className={styles.error}>
                            <i className="icon-window-error"></i>
                            <p className={styles['error-legend-title']}>Ups... Consultamos la base de datos, pero no encontramos ningún procedimiento que coincida con tu búsqueda.</p>
                            <p className={styles['error-legend-note']}>¿Querés volver a ver todo? Solo borrá el texto del buscador.</p>
                        </div>
                    ) : (
                        resultadosFiltrados.map((item) => {
                            const isExpanded = estaExpandido(item.idConvocatoria);

                            return (
                                <div
                                    key={item.idConvocatoria}
                                    className={`${styles.call} ${isExpanded ? styles['call-expanded'] : styles['call-collapsed']}`}
                                >
                                    <button
                                        className={styles['call-title']}
                                        onClick={() => {
                                            if (!searchTerm) toggleExpansion(item.idConvocatoria);
                                        }}
                                        disabled={!!searchTerm}
                                    >
                                        <p>{item.numConvocatoria}</p>
                                    </button>

                                    {isExpanded && (
                                        <div className={styles.procedures}>
                                            {item.procedimientos.map((item1) => (
                                                <React.Fragment key={item1.numProcedimiento}>
                                                    <hr className={styles.separator} />
                                                    <section className={styles.procedure}>
                                                        <div className={styles['procedure-data']}>
                                                            <p className={styles['procedure-subtitle']}>
                                                                {item1.numProcedimiento}
                                                            </p>
                                                            <p className={styles['procedure-name']}>
                                                                {item1.descripcionProcedimiento}
                                                            </p>
                                                            <div className={styles['procedure-extra-information']}>
                                                                <p className={styles['procedure-validity']}>
                                                                    <i className="icon-clock"></i>
                                                                    {item1.vigencia}
                                                                </p>
                                                                <a className={styles['procedure-download']} href={item1.urlAnexos}>
                                                                    <i title='Descargar anexos' className='icon-download-2'></i> Anexos
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className={styles['bidding-results']}>
                                                            <p className={styles['procedure-subtitle']}>Resultados.</p>
                                                            <div className={styles['links-results']}>
                                                                {item1.resultados.map((item2) => (
                                                                    <a className={styles.tagA} href={item2.urlresultado} target='_blank' key={item2.resultado}>
                                                                        <div className={styles['link-tender-results']}>
                                                                            <i className='icon-file-pdf'></i>
                                                                            <p>{item2.resultado}</p>
                                                                        </div>
                                                                    </a>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </section>
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
};

export default Licitaciones2018;
